<template>
    <transition
        v-on:enter="enter"
        v-on:leave="leave"
        v-on:after-enter="$emit('entered')"
        v-on:after-leave="$emit('left')"
        class="overflow-hidden"
        name="slide-down"
        :mode="dataMode"
        appear
    >
        <slot></slot>
    </transition>
</template>

<script>
import { gsap } from "gsap";

export default {
    props: ["mode", "speed"],

    data() {
        return {
            dataSpeed: this.speed ? this.speed : .4,
            dataMode: this.mode ? this.mode : 'in-out',
        }
    },

    methods: {
        enter(el, done) {
            gsap.set(el, {height:'auto'})
            gsap.from(el, this.dataSpeed, {height: 0, onComplete: done});
        },

        leave(el, done) {
            gsap.to(el, this.dataSpeed, {height: '0', onComplete: done});
        },
    }
}
</script>
<style>
    .slide-down-enter-active, .slide-down-leave-active {
        overflow:hidden;
    }
</style>
